import { TextFilterType } from '../../../../../types';
import { OperationState } from '../../../../../main/operations/operationsTypes';

export type UniversalFilterOperationStateStatus = OperationState;

export const enum UniversalFilterOperationStateModes {
  IS_ANY_OF = 'is_any_of',
  IS_NONE_OF = 'is_none_of'
}

export type UniversalFilterOperationStateValue = TextFilterType;

export type UniversalFilterOperationStateFilterState = {
  mode: UniversalFilterOperationStateModes;
  states?: UniversalFilterOperationStateStatus[];
};

export type UniversalFilterOperationStateOnFilterStateChange = (
  state: UniversalFilterOperationStateFilterState
) => void;

export type UniversalFilterOperationStateOnChange = (
  value?: UniversalFilterOperationStateValue
) => void;
